import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { PAGINAS, ROUTES, FUNCIONALIDADES } from '../../../routes';
import { getTiposStatusVagas } from './tipos_status_vagas.service';
import GridBase from '../../../components/grid_base';
export var TiposStatusVagasListar = function () {
    var COLUNAS_FUNCIONALIDADE = [
        { field: 'nome', headerName: 'Nome', width: 500 },
        { field: 'situacao', headerName: 'Situação', width: 150 },
    ];
    return (_jsx(GridBase, { pagina: PAGINAS.TIPOS_STATUS_VAGAS, paginaPermissao: FUNCIONALIDADES.TIPOS_STATUS_VAGAS, rota: ROUTES.TIPOS_STATUS_VAGAS, columns: COLUNAS_FUNCIONALIDADE, fetchData: function (str, _, pag) { return getTiposStatusVagas(str, pag); } }));
};
export default TiposStatusVagasListar;
